import { AssertByTypename } from '@/helpers/graphql-model-helper';
import { GetNodeTitleDetailsQuery } from '@/pages/graphql/queries/GetNodeTitleDetails.query';

export type UpcomingRelease = AssertByTypename<
	GetNodeTitleDetailsQuery['node'],
	'Movie' | 'Show' | 'Season'
>['content']['upcomingReleases'][number];

export function includeGenericReleases(
	unfilteredUpcomingReleases: UpcomingRelease[],
	upcomingReleases: UpcomingRelease[],
	hasCinemaOffers: boolean,
	hasDigitalOffers: boolean
) {
	const genericReleases = unfilteredUpcomingReleases.filter(
		release => !release.package || ['imd', 'tmd'].includes(release.package.shortName)
	);

	const genericDigital = genericReleases.find(release => release.releaseType === 'DIGITAL');
	const genericTheatrical = genericReleases.find(release => release.releaseType === 'THEATRICAL');

	// due to lack of confidence in theatrical generic release dates, we don't want to show them if there is a digital release with the same date
	// it may be that we expand the net to hide generic theatrical if there is any upcoming digital release, but for now just these
	const isGenericTheatricalWithSameDateAsDigitalUpcoming = upcomingReleases
		.filter(el => el.releaseType === 'DIGITAL')
		.some(el => genericTheatrical && el.releaseDate === genericTheatrical.releaseDate);

	const upcomingReleasesWithGeneric = [...upcomingReleases];

	if (!upcomingReleases.some(release => release.releaseType === 'DIGITAL') && !!genericDigital && !hasDigitalOffers) {
		upcomingReleasesWithGeneric.push(genericDigital);
	}

	if (
		!upcomingReleases.some(release => release.releaseType === 'THEATRICAL') &&
		!!genericTheatrical &&
		!hasCinemaOffers &&
		!isGenericTheatricalWithSameDateAsDigitalUpcoming
	) {
		upcomingReleasesWithGeneric.push(genericTheatrical);
	}

	return upcomingReleasesWithGeneric;
}
